import { format, parseISO } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { fr } from 'date-fns/locale';

export const PARIS_TZ = 'Europe/Paris';

const toDate = (date: Date | string): Date => (typeof date === 'string' ? parseISO(date) : date);

// Helper function to format dates with the French locale
export const formatDate = (date: Date | string, dateFormat: string): string =>
  format(toDate(date), dateFormat, { locale: fr });

// Affiche un instant absolu (heure de rendez-vous) en heure murale de Paris,
// quel que soit le fuseau du navigateur. À utiliser partout où l'on montre
// l'heure d'un RDV : sinon un visiteur hors de France voit une heure décalée
// par rapport au créneau qu'il a réellement réservé.
export const formatDateInParis = (date: Date | string, dateFormat: string): string =>
  formatInTimeZone(toDate(date), PARIS_TZ, dateFormat, { locale: fr });

// Google Calendar attend un instant en UTC (« ...Z »). On formate donc
// explicitement en UTC : formater dans le fuseau du navigateur puis coller un
// « Z » à la fin décale l'événement de l'offset local.
export const formatDateInUtc = (date: Date | string, dateFormat: string): string =>
  formatInTimeZone(toDate(date), 'UTC', dateFormat, { locale: fr });
